// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"4e324329","703":"b034ea6e","787":"857982c3"}[chunkId] + ".chunk.js";
};